import { render, staticRenderFns } from "./ordenGrupal.vue?vue&type=template&id=e62f01b2&scoped=true&"
import script from "./ordenGrupal.vue?vue&type=script&lang=js&"
export * from "./ordenGrupal.vue?vue&type=script&lang=js&"
import style0 from "./ordenGrupal.vue?vue&type=style&index=0&id=e62f01b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62f01b2",
  null
  
)

export default component.exports